import { render, staticRenderFns } from "./ShowStatistics.vue?vue&type=template&id=65280d62&scoped=true"
import script from "./ShowStatistics.vue?vue&type=script&lang=js"
export * from "./ShowStatistics.vue?vue&type=script&lang=js"
import style0 from "./ShowStatistics.vue?vue&type=style&index=0&id=65280d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65280d62",
  null
  
)

export default component.exports